import type { NetworkLossDetailSelectionParams } from '@gozoki/api-types'

export function buildNetworkLossDetailParams(
  selection: NetworkLossDetailSelectionParams,
): Record<string, string> | undefined {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')
  if (selection.storeAgeFilter) params.storeAgeFilter = selection.storeAgeFilter
  if (selection.ageStoreIds !== undefined)
    params.ageStoreIds = selection.ageStoreIds.length ? selection.ageStoreIds.join(',') : ''
  if (selection.comparableStoreIds?.length)
    params.comparableStoreIds = selection.comparableStoreIds.join(',')
  if (selection.categoryIds?.length) params.categoryIds = selection.categoryIds.join(',')
  if (selection.startDate) params.startDate = selection.startDate
  if (selection.endDate) params.endDate = selection.endDate
  if (selection.comparableStartDate) params.comparableStartDate = selection.comparableStartDate
  if (selection.comparableEndDate) params.comparableEndDate = selection.comparableEndDate

  return Object.keys(params).length ? params : undefined
}

export function buildNetworkLossDetailQueryKey(
  prefix: string,
  selection: NetworkLossDetailSelectionParams,
) {
  return [
    prefix,
    selection.storeIds,
    selection.storeAgeFilter,
    selection.ageStoreIds,
    selection.comparableStoreIds,
    selection.categoryIds,
    selection.startDate,
    selection.endDate,
    selection.comparableStartDate,
    selection.comparableEndDate,
  ] as const
}
